<template>

    <div>

        <div class="row mb-4">

            <div class="col col-md-12">
                <input-text
                    name="title"
                    label="Kontorets namn"
                    placeholder="T ex Göteborg"
                    custom-error-message="Ange ett namn för kontoret"
                    v-model="title"
                    formGroupClass="custom-form-section mb-0"
                />
            </div>

            <div class="col col-md-12">
                <input-check-radio
                    type="checkbox"
                    name="is_public"
                    label="Visa för anställda"
                    v-model="is_selectable"
                    :options="[
                        {value: true, label: 'Visa kontoret för anställda i registreringsformuläret'},
                    ]"
                    formGroupClass="custom-form-section mb-0 h-100"
                />
            </div>

        </div>
        <div class="w-100 d-flex justify-content-end">
            <button class="btn btn-primary" @click="patcherPatch()" :disabled="patcher.submitted">
                Spara uppgifter
            </button>
        </div>

        <div class="row mt-8">

            <div class="col col-md-24">

                <h3>Kontaktpersoner</h3>
                <contact-row
                    :key="'c'+contact.id"
                    :contact="contact"
                    v-for="contact in workplace.contacts"
                    @refresh="$emit('refresh')"
                />

                <button class="btn btn-info mt-4 float-end" @click="posterPost()" :disabled="poster.submitted">
                    + Lägg till kontaktperson
                </button>

            </div>

        </div>

        <div class="row mt-16" v-if="is_deleteable">
            <div class="col">
                <div class="w-100 d-flex justify-content-end">
                    <button class="btn btn-danger" @click="triggerDelete()" :disabled="deleter.submitted">
                        Radera arbetsplatsen
                    </button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import poster from '../../../../shared/mixins/poster'
import deleter from '../../../../shared/mixins/deleter'

import contactRow from './modal-info-contact-row'

export default {

    mixins: [
        patcher,
        poster,
        deleter
    ],

    components: {
        contactRow
    },

    props: {
        workplace: {
            required: true
        },
        is_deleteable: {
            required: true
        }
    },

    data () {
        return {
            title: this.workplace.title,
            is_selectable: this.workplace.is_selectable
        }
    },

    computed: {
        posterUrl () {
            return '/workplaces/' + this.workplace.id + '/contacts'
        },

        posterData () {
            return {
            }
        },

        patcherUrl () {
            return '/workplaces/' + this.workplace.id
        },

        patcherData () {
            return {
                title: this.title,
                is_selectable: this.is_selectable
            }
        },

        deleterUrl () {
            return '/workplaces/' + this.workplace.id
        }
    },

    methods: {
        posterSuccess () {
            this.$emit('refresh')
            bus.$emit(
                'notify',
                'Kontaktperson har lagts till.'
            )
        },
        patcherSuccess () {
            this.$emit('refresh')
            bus.$emit(
                'notify',
                'Ändringarna har sparats.'
            )
        },

        triggerDelete () {
            if (confirm('Vill du verkligen ta bort arbetsplatsen? Tänk på att inlagda kontaktpersoner försvinner och behöver läggas upp på en annan arbetsplats.')) {
                this.deleterDelete()
            }
        },

        deleterSuccess () {
            this.$emit('close')
            bus.$emit(
                'notify',
                'Arbetsplatsen har raderats.'
            )
        }
    }
}
</script>
